// extracted by mini-css-extract-plugin
export default {"price":"bEvUw","price--align":"nrwIZ","price__value":"oQiiW","price__currency":"sH7Wq","price__unit":"RZvZ0"};